import { getInlineLoader } from "../Helpers";
import certificatePdf from "../assets/certificate.pdf";
import tinPdf from "../assets/tin.pdf";

const documents = [
  {
    title: "Company Certificate",
    description: "Official registration and certification document.",
    file: certificatePdf,
    tag: "Certified"
  },
  {
    title: "Tax Identification (TIN)",
    description: "Official tax compliance and identification record.",
    file: tinPdf,
    tag: "Verified"
  },
];

export default function Certification() {
  return (
    <section className="py-5" style={{ background: "#f9fafb", minHeight: "100vh" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h1 className="font-bold text-secondary">Company Documents</h1>
          <p className="text-muted">Direct document verification and previews.</p>
        </div>

        <div className="row g-4">
          {documents.map((doc) => (
            <div key={doc.title} className="col-lg-6">
              <div className="card border-0 shadow-sm" style={{ borderRadius: "20px", overflow: "hidden" }}>
                <div className="card-body p-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h2 className="h5 fw-bold mb-0">{doc.title}</h2>
                    <span className="badge bg-primary bg-opacity-10 text-primary">{doc.tag}</span>
                  </div>
                  
                  {/* PREVIEW CONTAINER */}
                  <div 
                    style={{ 
                      width: "100%", 
                      height: "600px", 
                      backgroundColor: "#e9ecef", 
                      borderRadius: "12px",
                      position: "relative"
                    }}
                  >
                    <object
                      data={`${doc.file}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`}
                      type="application/pdf"
                      width="100%"
                      height="100%"
                      aria-label={`${doc.title} preview`}
                      style={{
                        border: "none",
                        borderRadius: "12px",
                        display: "block"
                      }}
                    >
                      <div className="h-100 d-flex flex-column justify-content-center align-items-center text-center p-4">
                        {getInlineLoader()}
                        <p className="text-muted mt-3 mb-2">
                          Preview is loading. If your browser blocks inline PDFs, open the document directly.
                        </p>
                        <a
                          href={doc.file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary"
                        >
                          Open {doc.title}
                        </a>
                      </div>
                    </object>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
